// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .loading-spinner{margin:0 auto;border:3px solid rgba(0,0,0,.5);border-bottom-color:#000;border-radius:50%;box-sizing:border-box;animation:rotation 1s linear infinite}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}#cz2.cz2.cz2__is-mariners .loading-spinner{border:3px solid hsla(0,0%,100%,.5);border-bottom-color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
